import React from "react";
import { useDAW } from "./DAWProvider";

const PIXELS_PER_BEAT = 60;

export default function TimelineRuler() {
  const { arrangementBars, barDuration } = useDAW();

  const beatsPerBar = 4;
  const totalBeats = arrangementBars * beatsPerBar;
  const totalWidth = totalBeats * PIXELS_PER_BEAT;

  return (
    <div className="daw-ruler" style={{ width: totalWidth }}>
      {Array.from({ length: totalBeats }, (_, beatIndex) => {
        const barIndex = Math.floor(beatIndex / beatsPerBar);
        const beatInBar = beatIndex % beatsPerBar;
        const isBarStart = beatInBar === 0;
        const timeAtBeat = beatIndex * (barDuration / beatsPerBar);

        return (
          <div
            key={beatIndex}
            className={`daw-ruler__beat${isBarStart ? " daw-ruler__beat--bar" : ""}`}
            style={{ width: PIXELS_PER_BEAT }}
          >
            {isBarStart && (
              <>
                <span className="daw-ruler__bar-num">{barIndex + 1}</span>
                <span className="daw-ruler__time">{formatTime(timeAtBeat)}</span>
              </>
            )}
            <div className="daw-ruler__tick" />
          </div>
        );
      })}
    </div>
  );
}

function formatTime(seconds) {
  const m = Math.floor(seconds / 60);
  const s = seconds % 60;
  return `${m}:${s.toFixed(1).padStart(4, "0")}`;
}

export { PIXELS_PER_BEAT };
